import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterHelper } from '../../core/utilities/router-helper';
import { AuthService } from '../../core/security/auth.service';
import { CurrentUser } from '../../api/models/current-user';
import { Subscription } from 'rxjs';
import { RolesEnum } from '../../core/security/roles.enum';
import { environment } from '../../../environments/environment';
import { HeaderService } from '../../core/services/header.service';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from '../../dialogs/logout/logout.component';
import { MatSwitchCompanyDialogComponent } from '../../dialogs/mat-switch-company-dialog/mat-switch-company-dialog.component';
import { MatMiniFabButton, MatButton, MatAnchor } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass, NgIf } from '@angular/common';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatCard, MatCardContent, MatCardFooter } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TwoFactorSetupDialogComponent } from '../../dialogs/two-factor-setup-dialog/two-factor-setup-dialog.component';

@Component({
  selector: 'app-new-current-user',
  templateUrl: './current-user.component.html',
  styleUrls: ['./current-user.component.scss'],
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatTooltip,
    NgClass,
    MatMenuTrigger,
    MatMenu,
    MatCard,
    MatCardContent,
    FlexModule,
    NgIf,
    MatIcon,
    MatButton,
    MatAnchor,
    RouterLink,
    MatCardFooter,
  ],
})
export class CurrentUserComponent implements OnInit, OnDestroy {
  profileUrl: string;
  userInitials: string;
  userName: string;
  userEmail: string;
  customerProfileName: string;
  version: string;
  hasEditAccess = false;
  isBetaCustomer = false;
  hasMultipleCompanies = false;
  currentUser: CurrentUser | undefined;

  private currentUserSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private headerService: HeaderService,
    public dialog: MatDialog,
  ) {
    const profileModule = RouterHelper.getRouteByComponent('ProfileComponent');
    this.profileUrl = this.headerService.themePrefix + profileModule.path;

    this.hasEditAccess = this.authService.hasAccess([RolesEnum.AccountProfile_View, RolesEnum.AccountProfile_Edit]);

    this.version = environment.version;
  }

  updateUserDisplay(user: CurrentUser) {
    this.currentUser = user;
    if (user) {
      this.userInitials = user.initials;
      this.userName = user.displayName;
      this.userEmail = user.username;
      this.isBetaCustomer = user.isBetaCustomer;
      this.customerProfileName = user.customerProfileName;
      this.hasMultipleCompanies = user.accounts.length > 1;

      this.checkIfNeedToForceTwoFactor().then();
    } else {
      this.userInitials = 'O';
      this.userName = '';
      this.userEmail = '';
      this.isBetaCustomer = false;
      this.customerProfileName = '';
      this.hasMultipleCompanies = false;
    }
  }

  async checkIfNeedToForceTwoFactor(): Promise<void> {
    if (this.currentUser && this.currentUser?.impersonator?.admin) {
      return;
    }

    if (this.currentUser && !this.currentUser.twoFactorEnabled && this.currentUser.force2FASetup) {
      const setupDialog = this.dialog.open(TwoFactorSetupDialogComponent, {
        width: '500px',
        height: '500px',
        disableClose: true,
      });

      setupDialog.afterClosed().subscribe(async result => {
        if (!result) {
          await this.authService.logout();
        } else {
          this.authService.alive(true).then();
        }
        //this.profileModel = await this.accountService.getUserProfile();
        //this.ngOnChanges();
      });
    }
  }

  ngOnInit() {
    this.currentUserSubscription = this.authService.currentUser.subscribe(value => {
      this.updateUserDisplay(value);
    });
  }

  ngOnDestroy(): void {
    this.currentUserSubscription?.unsubscribe();
  }

  logoutConfirm() {
    this.dialog.open(LogoutComponent, {
      width: '400px',
    });
  }

  openSwitchCompanyDialog() {
    this.dialog.open(MatSwitchCompanyDialogComponent, {
      width: '500px',
    });
  }
}
